import {
  GET_ALL_APP_USERS,
  GET_APP_USER,
  GET_EXT_USER,
  GET_JOB_TITLES,
  GET_MANAGERS_USERS,
} from '../actionTypes';
const defaultState = {
  usersList: [],
  jobTitles: [],
  selectedUser: {},
  selectedExrUser:{},
  managersUsers: [],
};
export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_ALL_APP_USERS:
      return {
        ...state,
        usersList: action.payload || defaultState.usersList,
      };
    case GET_APP_USER:
      return {
        ...state,
        selectedUser: action.payload || defaultState.selectedUser,
      };
    case GET_EXT_USER:
      return {
        ...state,
        selectedExrUser: action.payload || defaultState.selectedExrUser,
      };  
    case GET_JOB_TITLES:
      return {
        ...state,
        jobTitles: action.payload || defaultState.jobTitles,
      };
    case GET_MANAGERS_USERS:
      return {
        ...state,
        managersUsers: action.payload || defaultState.managersUsers,
      };
    default:
      return state;
  }
};
